import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs"

export const difficultyLevelEditApi = createAsyncThunk(
    'auth/difficulty-level',
    async (data, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.patch(apiRoutes.difficultyLevelAction(`${data.id}`, 1), data)
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)

const difficultyLevelEditSlice = createSlice({
    name: 'difficulty-level Edit',
    initialState: { result: [], loading: false, error: null, message: "" },
    extraReducers: (builder) => {
        builder.addCase(difficultyLevelEditApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(difficultyLevelEditApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.result
            state.message = action?.payload?.message
        })
        builder.addCase(difficultyLevelEditApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})

export const difficultyLevelEditReducer = difficultyLevelEditSlice.reducer